import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Space,
  Button,
  Tag,
  Modal,
  Popconfirm,
  message,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { EditOutlined, DeleteOutlined, BulbOutlined } from "@ant-design/icons";
import { Form } from "antd";
import { AuthContext } from "../../../context/auth-context/AuthContext";
import apiService from "../../../services/apiServices";
import ModalEditar from "./ModalEditar";
import ModalCrear from "./ModalCrear";

import { render } from "@testing-library/react";


export const AdminComponent = ({ isDarkMode, changeTheme, handleLogout }) => {
  const [users, setUsers] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [editingUser, setEditingUser] = useState(null);
  const [open, setOpen] = useState(false);
  const [form] = Form.useForm();
  //tomemos el authState desde el context
  const { authState, handleRefreshToken } = React.useContext(AuthContext);
  //const [listUsers, setlistUsers] = useState([])
  const [createModalOpen, setCreateModalOpen] = useState(false);  

  const handleGlobalSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
    const filtered = users.filter((u) =>
      `${u.firstName} ${u.lastName}`.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const getDataUsers = async () => {
    try {
      const tokenVerified = await handleRefreshToken();
      const datosUsuarios = await apiService.getUsersList(tokenVerified);
      return datosUsuarios;
    } catch (error) {
      console.error("Error fetching users:", error);
      message.error("Error al cargar los usuarios");
      return null;
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={confirm}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={confirm}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button onClick={clearFilters} size="small" style={{ width: 90 }}>
            Limpiar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
  });

  const handleEdit = (user) => {
   console.log("%c DATOS DEL REGISTRO DE USUARIO A EDITAR","color: teal", user); 
    setEditingUser(user);
//    console.log("%c STATE EDITITNG USER","color: green", editingUser);
    form.setFieldsValue(user);
    setOpen(true);
  };

  const handleSave = () => {
    form.validateFields().then((values) => {
      const newData = users.map((u) =>
        u.id === editingUser.id ? { ...u, ...values } : u
      );
      setUsers(newData);
      setFilteredData(newData);
      setOpen(false);
      message.success("Usuario actualizado");
    });
  };

  const handleDelete = async(id) => {
    try {
      const tokenVerified = await handleRefreshToken();
      const res = await apiService.deleteOneUser(id, tokenVerified);
      if (!res.ok && res.error) {
        message.error(res.error || "Error al eliminar el usuario");
        return false;
      }
      //console.log("%c RES EN HANDLE DELETE","color: yellow", res);
      message.success("Usuario eliminado exitosamente");
      setRefreshTable(prev => !prev);
      // const newData = users.filter((u) => u.id !== id);
      // setUsers(newData);
      // setFilteredData(newData);
    } catch (error) {
      console.error("%c ERROR EN HANDLE DELETE","color: red", error);
      message.error("Error al eliminar el usuario");
      return false;  
    }   

  };

  const columns = [
    {
      title: "Nombre",
      key: "firstName",
      render: (_, record) => `${record.firstName} ${record.lastName}`,
      ...getColumnSearchProps("firstName"),
    },
    {
      title: "Usuario",
      dataIndex: "username",
      key: "username",
      ...getColumnSearchProps("username"),
    },
    {
      title: "Correo",
      dataIndex: "email",
      key: "email",
      ...getColumnSearchProps("email"),
    },
    {
      title: "Rol",
      dataIndex: "role",
      key: "role",
      filters: [
        { text: "SUPER_ADMIN", value: "SUPER_ADMIN" },
        { text: "ADMIN", value: "ADMIN" },
        { text: "USER", value: "USER" },
      ],
      onFilter: (value, record) => record.role === value,
    },
    {
      title: "Suscripción",
      dataIndex: "subscription",
      key: "subscription",
      filters: [
        { text: 'Free', value: 'free' },
        { text: 'Mensual', value: 'mensual' },
        { text: 'Anual', value: 'anual' },
      ],
      onFilter: (value, record) => record.subscription === value,
    },    

    {
      title: "Estado Suscripción",
      dataIndex: "subscriptionStatus",
      key: "subscriptionStatus",
      filters: [
        { text: "Active", value: "active" },
        { text: "Pendiente", value: "pending" },
        { text: "Suspendido", value: "suspend" },
        { text: "Cancelado", value: "cancel" },
      ],
      onFilter: (value, record) => record.subscriptionStatus === value,
    },
    {
      title: "Fecha Fin Suscripción",
      dataIndex: "subscriptionEndDate",
      key: "subscriptionEndDate",      
      render: (val) => new Date(val).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }),
    },
    {
      title: "Plan",
      dataIndex: "plan",
      key: "plan",
      filters: [
        { text: "Starter", value: "starter" },
        { text: "Professional", value: "professional" },
        { text: "Corporate", value: "corporate" },
      ],
      onFilter: (value, record) => record.plan === value,
    },

    {
      title: "Experiencias Creadas",
      dataIndex: "experienceCount",
      key: "experienceCount",
      render: (val) => val || 0,
    },
    {
      title: "Límite de Experiencias",
      dataIndex: "experienceLimit",
      key: "experienceLimit",
      render: (val) => val || 3,
    },    

    {
      title: "Creado",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (val) => new Date(val).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }),

    },
    {
      title: "Actualizado",
      dataIndex: "updatedAt",
      key: "updatedAt",
      render: (val) => new Date(val).toLocaleDateString('es-ES', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }),

    },
    {
      title: "Acciones",
      key: "actions",
      render: (_, user) => (
        <Space>
          <Button onClick={() => handleEdit(user)} type="link">
            Editar
          </Button>
          <Popconfirm
            title="¿Eliminar este usuario?"
            onConfirm={() => handleDelete(user.id)}
          >
            <Button danger type="link">
              Eliminar
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];


  const [refreshTable, setRefreshTable] = useState(false);
  useEffect(() => {
    const fetchUsers = async () => {
      const data = await getDataUsers();
      data.sort((a, b) => a.lastName.localeCompare(b.lastName));
      if (data) {
        console.log("%c DATA EN FETCH USERS","color: blue", data);
        setUsers(data);
        setFilteredData(data);
      }
    };

    fetchUsers();
  }, [refreshTable]);  

  return (
    <div>
      <div style={{ position: 'relative', marginBottom: 16 }}>
        <h2 
          style={{ 
            color: isDarkMode ? "white" : "black",
            textAlign: 'center',
            margin: '0',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)'
          }}
        >
          Administración de Usuarios
        </h2>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="primary"
            style={{ marginRight: 8 }}
            onClick={() => setCreateModalOpen(true)}
          >
            Crear Usuario
          </Button>
          <Button
            type="primary"
            icon={<BulbOutlined />}
            onClick={changeTheme}
          ></Button>
        </div>
      </div>

      <Input
        placeholder="Buscar por nombre..."
        value={searchText}
        onChange={handleGlobalSearch}
        style={{ width: 300, marginBottom: 16 }}
      />

      <Table
        rowKey="id"
        columns={columns}
        dataSource={filteredData}
        pagination={{ pageSize: 5 }}        
        scroll={{ x: 1500 }} // Add horizontal scroll
        style={{ overflowX: 'auto' }} // Ensure horizontal scroll works
      />
      <ModalEditar open={open} setOpen={setOpen} setRefreshTable={setRefreshTable} data={editingUser} handleLogout={handleLogout} />
      <ModalCrear createModalOpen={createModalOpen} setCreateModalOpen={setCreateModalOpen} setRefreshTable={setRefreshTable}/>      
    </div>
  );
};
